/**
 * 📦 V2 Fornecedores API client
 * Rotas /api/v2/suppliers (vínculo Fornecedor × produto físico — até 3 por item)
 * Spec: docs/V2/FEATURES/OPERADOR_E_FORNECEDORES.md
 */

import v2Api from './index';

export const suppliersV2API = {
  /**
   * Convida fornecedor por email pra um slot (1..3) de um produto físico.
   * Body: { physical_product_id, email, supplier_position, fixed_amount_cents }
   * Resposta: { mode: 'linked' | 'invited', supplier? | invite? }
   */
  invite: (data) => v2Api.post('/suppliers/invite', data),

  /** Lista todos os fornecedores dos físicos de um produto. */
  listByProduct: (productId) => v2Api.get(`/suppliers/by-product/${productId}`),

  /** Lista até 3 fornecedores ativos de um produto físico, ordenados por slot. */
  listByPhysicalProduct: (physicalProductId) =>
    v2Api.get(`/suppliers/by-physical-product/${physicalProductId}`),

  /** Body: { fixed_amount_cents } */
  updateFixedAmount: (physicalProductId, position, data) =>
    v2Api.patch(`/suppliers/by-physical-product/${physicalProductId}/slot/${position}`, data),

  removeSlot: (physicalProductId, position) =>
    v2Api.delete(`/suppliers/by-physical-product/${physicalProductId}/slot/${position}`),
};

export default suppliersV2API;
